<div class="lr-p-15">
  <div class="row-no-margin col-md-12 clear-padding">
    <span class="section-header">{{IsCreate ? "Create" : "Edit"}} Custom Lead Time </span>
  </div>
  <div class="row-no-margin col-md-12">
    <div class="col-md-6 clear-padding">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Test:</mat-label>
        <input matInput class="mat-focused" placeholder="Test" [(ngModel)]="CurrentRule.RuleTest" />
      </mat-form-field>
    </div>
    <div class="col-md-4 lr-p-15">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Lead Time Days:</mat-label>
        <input matInput class="mat-focused" placeholder="Days" [(ngModel)]="CurrentRule.LeadTimeDays" />
      </mat-form-field>
    </div>
    </div>
  <div class="row-no-margin col-md-12">
    <div class="col-md-8 clear-padding">
      <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
        <mat-label>Custom Message</mat-label>
        <input matInput class="mat-focused" placeholder="Message" [(ngModel)]="CurrentRule.CustomMessage" />
      </mat-form-field>
    </div>
    <div class="col-md-4 lr-p-15">      
      <mat-form-field>
        <mat-label>Expiration Date</mat-label>
        <input matInput [matDatepicker]="expirationDatePicker" [value]="CurrentRule.ExpirationDate" (dateChange)="SetExpirationDate($event)">
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="expirationDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #expirationDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="row-no-margin col-md-12 justify-content-center">
    <!--buttons-->
    <button class="blue" (click)="SaveRule()">Save</button>&nbsp;
    <button class="blue" (click)="CloseWindow()">Close</button>
  </div>
</div>
